import { Provider } from '@angular/core';
import { MICROSOFT_CLIENT_ID, MICROSOFT_TENANAT_ID } from '@services';

export function provideMicrosoftClientId(apiKey: string): Provider[] {
  return [{ provide: MICROSOFT_CLIENT_ID, useValue: apiKey }];
}

export function provideMicrosoftTenantId(apiKey: string): Provider[] {
  return [{ provide: MICROSOFT_TENANAT_ID, useValue: apiKey }];
}
